import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export default function SalaryBreakdownTable({ rows = [] }) {
  if (!rows.length) return null;

  return (
    <Table
      sx={{ width: '50%', alignSelf: 'flex-end', border: '2px solid', borderColor: 'grey.300' }}
    >
      <TableBody>
        {rows.map(({ label, value }) => (
          <TableRow
            key={label}
            sx={{
              borderBottom: '2px solid',
              borderColor: 'grey.300',
              '&:last-child': { border: 0 },
            }}
          >
            <TableCell
              sx={{
                borderRight: '2px solid',
                borderColor: 'grey.300',
                width: '50%',
                padding: '8px 12px',
              }}
            >
              {label}
            </TableCell>
            <TableCell align='right' sx={{ padding: '8px 12px' }}>
              {value}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
